import { useColorModeValue } from '@chakra-ui/react';

export default function useColors() {
  return {
    text: {
      'default': useColorModeValue('gray.600', 'gray.400'),
      active: useColorModeValue('elvor.700', 'elvor.100'),
      hover: 'link_hovered',
    },
    bg: {
      'default': 'transparent',
      active: useColorModeValue('elvor.50', 'rgba(255, 159, 28, 0.12)'),
    },
    border: {
      'default': 'divider',
      active: useColorModeValue('elvor.50', 'rgba(255, 159, 28, 0.28)'),
    },
  };
}
